import { Container } from "../../UI/container/Container";
import { useColors } from "../../../hooks/colors/useColors";
import { ReactChildren } from "../../../services/model/types";
import { isMobile } from "react-device-detect";

type InputProps = {
  height?: number | string;
};
export function PageHeader(props: ReactChildren & InputProps) {
  const { colors } = useColors();
  const height = props.height ? props.height : isMobile ? 200 : 320;

  return (
    <div
      style={{
        backgroundImage: "url(/img/assessment.jpg)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
        height: height,
      }}
    >
      <div
        style={{
          backgroundColor: colors.primary,
          opacity: 0.9,
          // width: "100vw",
          height: height,
        }}
        className="flex justify-center items-center"
      >
        <Container noHeight>{props.children}</Container>
      </div>
    </div>
  );
}
